import script from "./Setting.vue?vue&type=script&setup=true&lang=js"
export * from "./Setting.vue?vue&type=script&setup=true&lang=js"

import "./Setting.vue?vue&type=style&index=0&id=1910b3cc&scoped=true&lang=less"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1910b3cc"]])

export default __exports__